import type { StudyPathway } from "@shikaku/shared";

export const studyPathways: StudyPathway[] = [
  {
    id: "common",
    title: "共通",
    subtitle: "課目I エネルギー総合管理・法規から始める",
    units: ["課目I エネルギー総合管理", "課目I 法規"],
    icon: "grid-2x2",
    iconForeground: "#167076",
    iconBackground: "#dff1f2",
  },
  {
    id: "thermal",
    title: "熱分野",
    subtitle: "熱と流体・燃焼・熱利用設備をまとめて学ぶ",
    units: [
      "熱分野 課目II 熱と流体の基礎",
      "熱分野 課目III 燃料と燃焼",
      "熱分野 課目IV 熱利用設備",
    ],
    icon: "flame",
    iconForeground: "#b14c1d",
    iconBackground: "#fceadf",
  },
  {
    id: "electrical",
    title: "電気分野",
    subtitle: "電気の基礎・設備機器・電力応用をまとめて学ぶ",
    units: [
      "電気分野 課目II 電気の基礎",
      "電気分野 課目III 電気設備及び機器",
      "電気分野 課目IV 電力応用",
    ],
    icon: "bolt",
    iconForeground: "#c88f15",
    iconBackground: "#fbf3db",
  },
];
